module.exports = __webpack_public_path__ + "static/scotchsoda-ddb055ab03960f04a2e66a078d8b07b2.jpg";